export enum RouteKey {
  WorkspaceTab = 'WorkspaceTab',
  SubmissionAutonomousCreation = 'SubmissionAutonomousCreation',
  SubmissionEdit = 'SubmissionEdit',
  SubmissionEditBOR = 'SubmissionEditBOR',
  Quote = 'Quote',
  ConceptualTower = 'ConceptualTower',
  ExpiringTower = 'ExpiringTower',
  Home = 'Home',
  EmailReply = 'EmailReply',
  QuoteStatusRequest = 'QuoteStatusRequest',
  Marketing = 'Marketing',
  MarketingReport = 'MarketingReport',
  YoYReport = 'YoYReport',
  TemplatesPage = 'TemplatesPage',
  NewSubmission = 'NewSubmission',
  QuoteStatus = 'QuoteStatus',
  AddMarkets = 'AddMarkets',
  AddProducts = 'AddProducts',
  SelectProducts = 'SelectProducts',
  AcknowledgmentEmail = 'AcknowledgmentEmail',
  UserMarket = 'UserMarket',
  Carrier = 'Carrier',
  Agency = 'Agency',
  Agent = 'Agent',
  SingleMarket = 'SingleMarket',
  CreateCustomerContact = 'CreateCustomerContact',
  EmailEditor = 'EmailEditor',
  CompareQuotes = 'CompareQuotes',
  QuoteComparisonInsights = 'QuoteComparisonInsights',
  CompareQuotesSideBySide = 'CompareQuotesSideBySide',
  MarketingUpdate = 'MarketingUpdate',
  MarketingUpdateEmail = 'MarketingUpdateEmail',
  Solicitation = 'Solicitation',
  ProposalFlow = 'ProposalFlow',
  FlowBinder = 'FlowBinder',
  EditExpiringPolicy = 'EditExpiringPolicy',
}
